import { ChangeDetectorRef, Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { ApiService } from 'app/shared/services/api.service';
import { SessionStorageService } from 'app/shared/services/session-storage.service';
import { environment } from 'environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import swal from 'sweetalert2';
import { DynamicDetailComponent } from '../../dynamic-detail/dynamic-detail.component';
import { AppState } from 'app/App Store/state';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { setPageNumber } from 'app/App Store/actions/pageChange.actions';
@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ListComponent implements OnInit {
  @ViewChild(DatatableComponent) table: DatatableComponent;
  page = {
    pageNumber: 0,
    offset: 0,
    pageSize: 10,
    totalPages: 0
  };
  activeTab = "open"
  // row data
  public rows = [];
  public filterRows = [];
  public ColumnMode = ColumnMode;
  public limitRef = 10;
  // column header
  public columns = [
    { name: "Lead Name", prop: "title" },
    { name: "Notes", prop: "notes" },
    // { name: "Email", prop: "email" },
    { name: "Lead Notes", prop: "notes" },
    { name: "Next Action", prop: "next_action" },
    { name: "Lead Stage", prop: "lead_stage" },
    { name: "Actions", prop: "actions" },
  ];
  trainingLead = '63e39db72052e0098e18e00e'
  softwarelead = '63e39dd62052e0098e18e015'
  productLead = '63e39df82052e0098e18e01c'
  digitalmarktLead = '63e39e1a2052e0098e18e023'
  private tempData = [];
  imageUrl = environment.apiUrls.imageUrl;
  @ViewChild('name') inputName;
  user_role: any
  currentUrl: any
  statusList: any;
  stageList: any;
  nextaction_tagcat_id = '63e39b572052e0098e18dfc2'
  nextactionList = []
  lead = {
    notes: '',
    next_action: '',
    last_activedate: '',
    lastresponse: '',
    next_action_date:null,
    next_action_time:null,
    priority:'',
    assign_to:[]
  }
  leadId: any
  input_option: any = {}
  count_h: any
  count_n: any
  count_l: any
  count_w: any
  cover_letter: any
  catId = '6319d5025ab9e462a96cfbba'
  technology_List = []
  selectedTechnology: any = null

  guideline_data:any
  activePage = 1
  pageNumberSubscription : Subscription
  pageNo
  isDumpData:boolean=false
  fileData:File;
  emp_list=[]
  selected_emp:[]=[]
  priority_list=[
    {name:'normal'},
    {name:'medium'},
    {name:'high'},
    {name:'urgent'},
  ]
  selected_priority='medium'
  clients_list =[]
  selected_client = null
  row_id:any
  constructor(public apiService: ApiService,
    public toastr: ToastrService, private modalService: NgbModal,
    private session: SessionStorageService, private spinner: NgxSpinnerService,
    private route: Router, private activerouter: ActivatedRoute,
    private cdRef: ChangeDetectorRef, private store: Store<AppState>) {
      
    this.currentUrl = this.activerouter.snapshot.routeConfig.path
    this.user_role = JSON.parse(localStorage.getItem('user'))
    this.getLeadsStatusList()

    if (this.currentUrl === 'training-leads') {
      let setting_data = JSON.parse(localStorage.getItem('setting-record'))
      let key_data = setting_data.filter((item) => item.key === 'Training Leads') 
      this.guideline_data = key_data[0]?._id
      this.activerouter.queryParams
      .subscribe((params: any) => {
        this.activeTab = params['status'];
        this.pageNo = +params['page'];
        if(this.pageNo>0){
          this.setPage(this.pageNo);
        }
        else this.page.pageNumber = this.pageNo?this.pageNo-1:0
      })
      this.pageNumberSubscription = this.store.select(state => state.page.pageNumber)
      .subscribe(pageNumber => {
        this.page.pageNumber = pageNumber;
        if(pageNumber !==undefined){
          this.page.pageNumber = pageNumber ?  pageNumber-1 :0
        }
      });
      if(this.activeTab) this.activeLeadsTab(this.activeTab,this.pageNo?this.pageNo:1)
      if(!this.activeTab) this.activeLeadsTab('open',this.pageNo?this.pageNo:1)
    }

    if (this.currentUrl !== 'training-leads') {
      let setting_data = JSON.parse(localStorage.getItem('setting-record'))
      let key_data = setting_data.filter((item) => item.key === 'Outsourcing Leads') 
      this.guideline_data = key_data[0]?._id

      this.activerouter.queryParams
      .subscribe((params: any) => {
        this.activeTab = params['status'];
        this.pageNo = +params['page'];
        if(this.pageNo>0){
          this.setPage(this.pageNo);
        }
        else this.page.pageNumber = this.pageNo?this.pageNo-1:0
      })
      this.pageNumberSubscription = this.store.select(state => state.page.pageNumber)
      .subscribe(pageNumber => {
        this.page.pageNumber = pageNumber;
        if(pageNumber !==undefined){
          this.page.pageNumber = pageNumber ?  pageNumber-1 :0
        }
      });
      if(this.activeTab) this.activeLeadsTab(this.activeTab,this.pageNo?this.pageNo:1)
      if(!this.activeTab) this.activeLeadsTab('open',this.pageNo?this.pageNo:1)
    }
    this.getAllEmpList()
    this.getUserById()
    this.getLeadsStageList()
    this.getClientList()

  }

  ngOnInit() {
    this.isDumpData=false
    this.getNextActionTags()
    this.getTechnologyList()
  }
  setPage(pageNumber: number) {
    this.store.dispatch(setPageNumber({ pageNumber }));
  }
  setAndGetLeadbyStatus() {
    this.activerouter.queryParams
      .subscribe((params: any) => {
        this.activeTab = params?.status;
        if (this.currentUrl === 'training-leads') {
          this.getLeadsByTagId(this.trainingLead)
        }
        else {
          this.getLeadsByTagId(this.softwarelead)
        }
      })
  }
  editLeads(row) {
    if (this.currentUrl === 'training-leads') {
      const url = '/leads/edit/' + row._id;
      window.open(url, '_blank');
    }
    if (this.currentUrl !== 'training-leads') {
      const url = 'leads/outsource-lead-edit/' + row._id;
      window.open(url, '_blank');
    }
  }
  activeLeadsTab(tab,page) {
    if(page<1){ page =1}
    const activetab = tab;
    this.activeTab = tab
    if (activetab !== '') {
      this.route.navigate(
        [],
        { relativeTo: this.activerouter, queryParams: { status: activetab,  page : page },queryParamsHandling: 'merge' }
      );
    }
  }
  getUserById() {
    this.apiService.getUserbyId(this.user_role.id).subscribe((res: any) => {
      let emp_data = res?.data
      this.selectedTechnology = emp_data?.technology[0]?.displayname
      if (emp_data?.technology.length == 0) {
        this.selectedTechnology = 'All'
      }
    })
  }

  getLeadsByTagId(id) {
    let status = this.statusList.find((item) => item.name == this.activeTab)
    if (this.currentUrl === 'training-leads') {
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
      this.apiService.getLeadsByTagId(this.page.pageNumber+1, this.limitRef, id, status._id, status.name).subscribe((res: any) => {
        this.spinner.hide()
        let mappedRows = res.items
        this.rows = mappedRows.map((row) => {
          return row
        });
        this.page.totalPages = res.total

        const categoryToCount_hot = 'Hot';
        const filteredItems = res.items.filter(item => item.lead_stage.displayname === categoryToCount_hot);
        this.count_h = filteredItems.length;

        const categoryToCount_nurture = 'Nurture';
        const filteredItems_n = res.items.filter(item => item.lead_stage.displayname === categoryToCount_nurture);
        this.count_n = filteredItems_n.length;

        const categoryToCount_won = 'Won';
        const filteredItems_w = res.items.filter(item => item?.lead_stage?.displayname === categoryToCount_won);
        this.count_w = filteredItems_w.length;

        const categoryToCount_lost = 'Lost';
        const filteredItems_l = res.items.filter(item => item.lead_stage.displayname === categoryToCount_lost);
        this.count_l = filteredItems_l.length;
      })
    }
    else {
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
      this.apiService.getOutsourceLeadsByTagId(this.page.pageNumber+1, this.limitRef, status._id, id,this.activeTab).subscribe((res: any) => {
        this.spinner.hide()
        let mappedRows = res.items
        this.rows = mappedRows.map((row) => {
          return row
        });
        // ------------ Sort By Lead Stage Name ------------------

        if (status.name == 'active') {
          this.rows = this.rows.sort((a, b) => {
            if (a.leads.lead_stage.name.toLowerCase() < b.leads.lead_stage.name.toLowerCase()) { return -1; }
            if (a.leads.lead_stage.name.toLowerCase() > b.leads.lead_stage.name.toLowerCase()) { return 1; }
            return 0;
          });
        }
        // ------------- End ---------------------------------

        this.page.totalPages = res.total

        const categoryToCount_hot = 'Hot';
        const filteredItems = res.items.filter(item => item.leads.lead_stage.displayname === categoryToCount_hot);
        this.count_h = filteredItems.length;

        const categoryToCount_nurture = 'Nurture';
        const filteredItems_n = res.items.filter(item => item.leads.lead_stage.displayname === categoryToCount_nurture);
        this.count_n = filteredItems_n.length;

        const categoryToCount_won = 'Won';
        const filteredItems_w = res.items.filter(item => item.leads.lead_stage.displayname === categoryToCount_won);
        this.count_w = filteredItems_w.length;

        const categoryToCount_lost = 'Lost';
        const filteredItems_l = res.items.filter(item => item.leads.lead_stage.displayname === categoryToCount_lost);
        this.count_l = filteredItems_l.length;

      })
    }
  }
  getLeadsStatusList() {
    this.apiService.getLeadsStatusList("leadstatus").subscribe((res: any) => {
      this.statusList = res.data
      this.setAndGetLeadbyStatus()
    })
  }
  getLeadsStageList() {
    this.apiService.getLeadsStatusList("leadstage").subscribe((res: any) => {
      this.stageList = res.data
    })
  }
  pageChangeData(page: any) {
    this.activePage = page.offset + 1
    this.route.navigate([], {
      relativeTo: this.activerouter,
      queryParams: { page: page.offset +1 },
      queryParamsHandling: 'merge' // keep existing query params
    });
    let openStatus = this.statusList.find((item) => item.name == this.activeTab)
    if (this.currentUrl === 'training-leads') {
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
      this.apiService.getLeadsByTagId(page.offset + 1, page.pageSize, this.trainingLead, openStatus._id, openStatus.name).subscribe((res: any) => {
        this.spinner.hide()
        this.setPage(page.offset + 1)
        this.rows = res.items
        this.page.totalPages = res.total
      })
    }
    else {
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
      this.apiService.getOutsourceLeadsByTagId(page.offset + 1, page.pageSize, openStatus._id, this.softwarelead,this.activeTab).subscribe((res: any) => {
        this.spinner.hide()
        this.setPage(page.offset + 1)
        this.rows = res.items
        this.page.totalPages = res.total
      })
    }
  }
  deleteTrainingLead(id) {
    if (this.currentUrl == 'training-leads') {
      this.apiService.deleteleads(id).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.setAndGetLeadbyStatus()
        }
      })
    }
  }
  deleteOutSourceLeads(id, password) {

    if (this.currentUrl !== 'training-leads') {
      this.apiService.deleteOutsourceLeads(id, password).subscribe((res: any) => {
        if (res.statusCode == 200) {
          swal.fire({
            icon: "success",
            title: 'Deleted!',
            text: 'Your file has been deleted.',
            customClass: {
              confirmButton: 'btn btn-success'
            },
          })
          this.setAndGetLeadbyStatus()
        }
        else {
          swal.fire({
            icon: "error",
            title: 'Error!',
            text: `${res.error}.`,
            customClass: {
              confirmButton: 'btn btn-success'
            },
          })
        }
      })
    }
  }
  updateLeadStage(id, stage) {
    let body = { lead_stage: stage }
    if (this.currentUrl == 'training-leads') {
      this.apiService.updateLeads(id, body).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.toastr.success("Updated Successfully")
          this.getLeadsByTagId(this.trainingLead)
        }
        else { this.toastr.error(res.error) }
      })
    }
    if (this.currentUrl !== 'training-leads') {

      this.apiService.updateOutSourceLeads(id, body).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.toastr.success("Updated Successfully")
          this.setAndGetLeadbyStatus()

        }
        else { this.toastr.error(res.error) }
      })
    }
  }
  updateLeadStatus(id, status) {

    let stage
    this.input_option = {}
    this.stageList.forEach(item => {
      if (status.name == 'open') {
        if (item.name === 'prospect') {
          this.input_option[item._id] = item.displayname;
          stage = item._id
        }
      }
      else if (status.name == 'active') {
        if (item.name === 'prospect' || item.name === 'hot' || item.name === 'nurture') this.input_option[item._id] = item.displayname;
        if (item.name == "prospect") stage = item._id
      }
      else if (status.name == 'closed') {
        if (item.name === 'won' || item.name === 'lost') this.input_option[item._id] = item.displayname;
        if (item.name == "lost") stage = item._id
      }
    });
    swal.fire({
      title: 'Select Lead Stage',
      input: 'select',
      inputOptions: this.input_option,
      inputValue: stage,
      inputPlaceholder: 'Select Lead Stage',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#2F8BE6',
      cancelButtonColor: '#F55252',
      confirmButtonText: 'Yes!',
      customClass: {
        confirmButton: 'btn btn-warning',
        cancelButton: 'btn btn-danger ml-1'
      },
      buttonsStyling: false,
    }).then((result) => {
      if (result.value) {
        let body = { lead_status: status._id, lead_stage: stage }
        const stageId = result.value;
        body.lead_stage = stageId
        if (this.currentUrl == 'training-leads') {
          this.apiService.updateLeads(id, body).subscribe((res: any) => {
            if (res.statusCode === 200) {
              swal.fire({
                icon: "success",
                title: 'Move!',
                text: 'Updated Successfully.',
                customClass: {
                  confirmButton: 'btn btn-success'
                },
              })
              this.setAndGetLeadbyStatus()
            }
            else {
              swal.fire({
                icon: "error",
                title: 'Move!',
                text: `${res.error}`,
                customClass: {
                  confirmButton: 'btn btn-success'
                },
              })
            }
          })
        }
        if (this.currentUrl !== 'training-leads') {
          this.apiService.updateOutSourceLeads(id, body).subscribe((res: any) => {

            if (res.statusCode === 200) {
              swal.fire({
                icon: "success",
                title: 'Move!',
                text: 'Updated Successfully.',
                customClass: {
                  confirmButton: 'btn btn-success'
                },
              })
              this.setAndGetLeadbyStatus()
            }
            else {
              swal.fire({
                icon: "error",
                title: 'Move!',
                text: `${res.error}`,
                customClass: {
                  confirmButton: 'btn btn-success'
                },
              })
            }
          })
        }

      } else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          text: 'Your file is safe :)',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });

  }
  showMoveTo(status, leadStatus) {
    if (leadStatus?.name == "closed" && status?.name !== "active") return true
    if (leadStatus?.name == "open" && status?.name !== "open") return true
    if (leadStatus?.name == "active" && status?.name !== "open" && status?.name !== "active") return true

  }
  // ================== Delete Alert ========================
  Delete(id: any) {
    if (this.currentUrl == 'training-leads') {
      swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2F8BE6',
        cancelButtonColor: '#F55252',
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-warning',
          cancelButton: 'btn btn-danger ml-1'
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteTrainingLead(id)
          swal.fire({
            icon: "success",
            title: 'Deleted!',
            text: 'Your file has been deleted.',
            customClass: {
              confirmButton: 'btn btn-success'
            },
          })
        } else if (result.dismiss === swal.DismissReason.cancel) {
          swal.fire({
            title: 'Cancelled',
            text: 'Your imaginary file is safe :)',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-success'
            },
          })
        }
      });
    }
    if (this.currentUrl !== 'training-leads') {
      swal.fire({
        text: "Please Enter Password",
        input: 'password',
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.deleteOutSourceLeads(id, result.value)

        } else if (result.dismiss === swal.DismissReason.cancel) {
          swal.fire({
            title: 'Cancelled',
            text: 'Your file is safe :)',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-success'
            },
          })
        }
      });
    }

  }


  // ==========================================
  getLeadsFilter(value: any) {
    let status = this.statusList.find((item) => item.name == this.activeTab)
    if (this.currentUrl ==='training-leads') {
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
      this.apiService.getLeadsSearch(this.trainingLead, value, status._id, this.activeTab).subscribe((res: any) => {
        this.spinner.hide()
        this.rows = res?.data
      })
    }
    else if (this.currentUrl !== 'training-leads') {
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
      this.apiService.getOutSourceLeadsSearch(value, this.activeTab).subscribe((res: any) => {
        this.spinner.hide()
        this.rows = res?.data
      })
    }
  }
  resetFilter() {
    this.inputName.nativeElement.value = null;
    this.isDumpData =false
    this.setAndGetLeadbyStatus()
  }
  openModal(content, data) {
    const options: NgbModalOptions = {
      size: 'md', // set the size of the modal
      backdrop: 'static', // set whether clicking outside the modal closes it
      centered: true // set whether the modal is centered vertically
    };
    if (this.currentUrl == 'training-leads') {
      this.lead.next_action = data.next_action._id
      this.lead.notes = data.contact_id.notes
      this.lead.last_activedate = data.last_activedate
      this.leadId = data._id
      this.modalService.open(content, options); // open the modal
    }
    else {
      this.lead.next_action = data.leads.next_action._id
      this.lead.notes = data.notes
      this.lead.last_activedate = data.leads.last_activedate
      this.lead.next_action_date = data.leads.next_action_date
      this.lead.next_action_time = data.leads.next_action_time
      this.lead.lastresponse = data.leads.lastresponse
      this.lead.notes = data.leads.notes
      this.leadId = data._id 
      this.selected_emp = data?.assign_to?.map((item) => item?._id)
      const modalRef = this.modalService.open(content,options);
    modalRef.result.then((result) => {
      this.selected_emp=null
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      this.selected_emp=null

      // console.log(`Modal dismissed with reason: ${reason}`);
    });
    }

  }
  getNextActionTags() {
    this.apiService.getTagByTagCatgoryId(this.nextaction_tagcat_id).subscribe((res: any) => {
      this.nextactionList = res.data
    })
  }
  getChangeNextAction(event) {
    this.lead.next_action
  }
  ngAfterViewInit(): void {
    this.cdRef.detectChanges();
  }
  updateLead() {
    if (this.currentUrl == 'training-leads') {
      this.apiService.updateLeads(this.leadId, this.lead).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.toastr.success("Updated Successfully")
          this.modalService.dismissAll()
          this.setAndGetLeadbyStatus()
        }
        else { this.toastr.error(res.error) }
      })
    }
    else {

      this.apiService.updateOutSourceLeads(this.leadId, this.lead).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.toastr.success("Updated Successfully")
          this.modalService.dismissAll()
          this.setAndGetLeadbyStatus()
        }
        else { this.toastr.error(res.error) }
      })
    }
  }
  copyLink(data) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = data.links
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.toastr.info('Link copied')
  }
  openLetter(content, data) {
    const options: NgbModalOptions = {
      size: 'lg', // set the size of the modal
      backdrop: 'static', // set whether clicking outside the modal closes it
      centered: true // set whether the modal is centered vertically
    };
    this.cover_letter = data.coverletter
    const modalRef = this.modalService.open(content,options);
    modalRef.result.then((result) => {
      this.cover_letter=''	
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      this.cover_letter=''	

      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }
  getRowClass(row: any) {
    const dateDiff = new Date().getTime() - new Date(row.updated_at).getTime();
    const daysDiff = Math.floor(dateDiff / (1000 * 60 * 60 * 24));
    return daysDiff >= 30 ? 'red-background' : '';
  }
  getTechnologyList() {
    this.apiService.getTagByTagCatgoryId(this.catId).subscribe((res: any) => {
      this.technology_List = res.data.slice(0, 4)
      let list = { _id: 'all', displayname: 'All' }
      this.technology_List.push(list)
      this.technology_List.sort((a, b) => {
        if (a.displayname < b.displayname) { return -1; }
        if (a.displayname > b.displayname) { return 1; }
        return 0;
      });
    })
  }
  getTechnologyId(event_id, event_name) {
    this.selectedTechnology = event_name
    if (event_id.displayname !== 'All' && this.selectedTechnology) {
      let formData = new FormData();
      formData.append('technology', event_id)
      this.apiService.updateUser(this.user_role.id, formData).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.getLeadsByTagId(this.softwarelead)
        }
        else {
          this.toastr.error(res.error)
        }
      })
    }
    else {
      let formData = new FormData();
      formData.append('technology', event_id._id)
      this.apiService.updateUser(this.user_role.id, formData).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.getLeadsByTagId(this.softwarelead)
        }
        else {
          this.toastr.error(res.error)
        }
      })
    }

  }

  currentStatusToClose(){
    let status = this.statusList.find((item) => item.name == this.activeTab)
    let current_status = status._id
    let training_type_id = '63e39db72052e0098e18e00e'
    let outsource_type_id = '63e39dd62052e0098e18e015'

    swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to Close this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#2F8BE6',
      cancelButtonColor: '#F55252',
      confirmButtonText: 'Yes!',
      customClass: {
        confirmButton: 'btn btn-warning',
        cancelButton: 'btn btn-danger ml-1'
      },
      buttonsStyling: false,
    }).then((result) => {
      if (result.value) {
        // const selectedValue = (document.getElementById('dropdown') as HTMLSelectElement).value;

        // if (selectedValue) {
            if(this.currentUrl === 'training-leads'){
              this.apiService.getLeadsMoveToCloseStatus(training_type_id,current_status,'63e3971b2052e0098e18defa').subscribe((res: any) => {
                if (res.statusCode === 200) {
                  swal.fire({
                    icon: "success",
                    title: 'Move!',
                    text: `${res.data.leads.n} Move to close status Successfully.`,
                    customClass: {
                      confirmButton: 'btn btn-success'
                    },
                  })
                  this.setAndGetLeadbyStatus()
                }
                else {
                  swal.fire({
                    icon: "error",
                    title: 'Move!',
                    text: `${res.error}`,
                    customClass: {
                      confirmButton: 'btn btn-success'
                    },
                  })
                }
              })
            }
            if(this.currentUrl === 'outsource-leads'){
              this.apiService.getLeadsMoveToCloseStatus(outsource_type_id,current_status,'63e3971b2052e0098e18defa').subscribe((res: any) => {
                if (res.statusCode === 200) {
                  swal.fire({
                    icon: "success",
                    title: 'Move!',
                    text: `${res.data.leads.n} Move to close status Successfully.`,
                    customClass: {
                      confirmButton: 'btn btn-success'
                    },
                  })
                  this.setAndGetLeadbyStatus()
                }
                else {
                  swal.fire({
                    icon: "error",
                    title: 'Move!',
                    text: `${res.error}`,
                    customClass: {
                      confirmButton: 'btn btn-success'
                    },
                  })
                }
              })
            }
        // }

      }
    });
  }
  deleteOutsourceLeadByCloseStatus(){
    swal.fire({
      text: "Please Enter Password",
      input: 'password',
      showCancelButton: true,
    }).then((result) => {
      if (result.value) {
        this.apiService.getOutSourceLeadsDeleteCloseStatus(result.value).subscribe((res:any)=>{
          if(res.statusCode === 200){
            swal.fire({
              icon: "success",
              title: 'Delete!',
              text: `${res.total} leads deleted successfully.`,
              customClass: {
                confirmButton: 'btn btn-success'
              },
            })
            this.setAndGetLeadbyStatus()
          }
          else {
            swal.fire({
              icon: "error",
              title: 'Move!',
              text: `${res.error}`,
              customClass: {
                confirmButton: 'btn btn-success'
              },
            })
          }
        })

      } else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          text: 'Your file is safe :)',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });
  }

  openDynamicModal(key_id:string) {
    const modalOptions: NgbModalOptions = {
      size: 'lg', // 'sm', 'lg', or 'xl'
      backdrop: 'static',
    };
    const modalRef = this.modalService.open(DynamicDetailComponent,modalOptions);
    modalRef.componentInstance.key_id = key_id;
  }
  monthYearWiseDump() {
  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from({ length: 10 }, (_, i) => currentYear - i); // Last 10 years

  const monthOptions = [
    { value: '01', label: 'January' },
    { value: '02', label: 'February' },
    { value: '03', label: 'March' },
    { value: '04', label: 'April' },
    { value: '05', label: 'May' },
    { value: '06', label: 'June' },
    { value: '07', label: 'July' },
    { value: '08', label: 'August' },
    { value: '09', label: 'September' },
    { value: '10', label: 'October' },
    { value: '11', label: 'November' },
    { value: '12', label: 'December' },
  ];

  swal.fire({
    title: 'Load Dump Data Month and Year Wise',
    html: `
      <div class="position-relative">
        <label class="position-absolute">Select Month</label>
        <select id="monthSelect" class="swal2-input">
          ${monthOptions.map(month => `<option value="${month.value}">${month.label}</option>`).join('')}
        </select>
      </div>
      <div class="position-relative">
        <label class="position-absolute">Select Year</label>
        <select id="yearSelect" class="swal2-input">
          ${yearOptions.map(year => `<option value="${year}">${year}</option>`).join('')}
        </select>
      </div>
    `,
    focusConfirm: false,
    showCancelButton: true,
  }).then((result) => {
    if (result.value) {
      const selectedMonth = (document.getElementById('monthSelect') as HTMLSelectElement).value;
      const selectedYear = (document.getElementById('yearSelect') as HTMLSelectElement).value;
      console.log('=>> month',selectedMonth,'==>> year',selectedYear)
      if (!selectedMonth || !selectedYear) {
        this.toastr.error('Please select both month and year');
      } else {
        this.loadDump(selectedMonth, selectedYear);
      }

    } else if (result.dismiss === swal.DismissReason.cancel) {
      swal.fire({
        title: 'Cancelled',
        text: 'Your file is safe :)',
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-success'
        },
      });
    }
  });
}

  loadDump(month,year) {
    this.isDumpData = true
    this.limitRef=1000
    this.spinner.show(undefined,
    {
      type: 'ball-triangle-path',
      size: 'medium',
      bdColor: 'rgba(0, 0, 0, 0.8)',
      color: '#fff',
      fullScreen: true
    });
    this.apiService.getAllDumpData(1, 1000,month,year).subscribe((res: any) => {
      this.spinner.hide()
      this.rows = res?.items?.items
      this.page.totalPages = res?.items?.totalCount
    })
}
onSelectFileCSV(event:any){
  if (event.target.files && event.target.files[0]) {
    var reader = new FileReader();
    this.fileData = event.target.files[0];
    reader.readAsDataURL(event.target.files[0]);
    this.uploadCSVFile()
  }
}
uploadCSVFile(){
  let formData=new FormData();
  formData.append('image',this.fileData)
  this.apiService.addTrainingLeadFile(formData).subscribe((res:any)=>{
    if(res.statusCode === 200){
      this.toastr.success('csv file upload successfully!')
      this.setAndGetLeadbyStatus()
    }
    else{
      this.toastr.error(res.error)
    }
  })
}
getAllEmpList(){
  this.apiService.getEmployeeList(1,100).subscribe((res:any)=>{
    this.emp_list=res?.items
  })
}
getEmpId(event:any){
  this.selected_emp
  this.lead.assign_to = this.selected_emp

}
getPriorityId(event:any){
  this.selected_priority
  this.lead.priority = this.selected_priority
}
updateTask(){
  let body={
    priority: this.selected_priority,
    assign_to :this.selected_emp
  }
  
  this.apiService.createleadActionReports(this.leadId, body).subscribe((res: any) => {
    if (res.isSuccess) {
      this.toastr.success("task assign Successfully")
    }
    else { this.toastr.error(res.error) }
  })
}

getClientList() {
  this.spinner.show(undefined,
   {
     type: 'ball-triangle-path',
     size: 'medium',
     bdColor: 'rgba(0, 0, 0, 0.8)',
     color: '#fff',
     fullScreen: true
   });
 // let status = this.type_List.find((item) => item.name == this.activeTab);
 this.apiService.getAllClients(1,100).subscribe((res: any) => {
   this.spinner.hide()
   let data = res?.data?.items
    this.clients_list = data?.map((item)=> item?.user_id[0])
 })
}
getClientId(event){
  this.selected_client
}
openModal2(content, id) {
  this.row_id = id

  const options: NgbModalOptions = {
    size: 'md', // set the size of the modal
    backdrop: 'static', // set whether clicking outside the modal closes it
    centered: true // set whether the modal is centered vertically
  };
  const modalRef = this.modalService.open(content,options);
  modalRef.result.then((result) => {
    // console.log(`Modal closed with result: ${result}`);
  }, (reason) => {

    // console.log(`Modal dismissed with reason: ${reason}`);
  });
}
updateClient(){
  let body={
    lead : this.row_id,
  }
  this.apiService.updateClient(this.selected_client,body).subscribe((res:any)=>{
    if(res?.isSuccess){
      this.toastr.success('Attach Client Successfully')
      this.modalService.dismissAll()
      this.setAndGetLeadbyStatus()
    }
    else this.toastr.error(res.error)
  })
}

}
